import React, { useState, useEffect } from "react";
import "styles/HeroNew.css";

const HeroNew = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const threshold = 150; // Punto donde se activa el navbar

      if (scrollY > threshold) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const backgroundStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/EliteVacances/Bannerinicio.jpg)`,
  };

  return (
    <section className="hero-new">
      {/* Fondo con overlay */}
      <div className="hero-new__background" style={backgroundStyle}>
        <div className="hero-new__overlay"></div>
      </div>

      {/* Contenido del hero */}
      <div className="hero-new__content">
        {/* Taglines */}
        <div className="hero-new__center">
          <div
            className={`hero-new__taglines ${
              isScrolled ? "hero-new__taglines--hidden" : ""
            }`}
          >
            <span className="hero-new__tagline">HOTELES</span>
            <span className="hero-new__tagline">VIAJES</span>
            <span className="hero-new__tagline">VACACIONES</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroNew;
